
import fetchData from '../utils/fetchData';


const updateUserInFirestore = async (uid, providerData) => {
    try {
        const apiUrl = `${process.env.REACT_APP_API_BASE_URL}ai/writer/v1/user/firebase/${uid}`;

        let providerIds = [];

        // Case 1: providerData is an array (e.g. from Firebase providerData list)
        if (Array.isArray(providerData)) {
            providerIds = providerData.map(p => p.providerId);
        }
        // Case 2: providerData is a string (already a providerId)
        else if (typeof providerData === "string") {
            providerIds = [providerData];
        }
        // Case 3: providerData is null/undefined
        else {
            providerIds = [];
        }


        const response = await fetchData({
            url: apiUrl,
            method: 'PATCH',
            body: { credentialProvider: providerIds }
        });

        return response;
    } catch (error) {
        console.error('Error updating user to Firestore:', error);
        throw error;
    }
};


export default updateUserInFirestore;